<template>
  <div class="guests-info-detail" @click="selectClick">
    <div class="detail-title">
      乘客<span class="detail-num">{{ guest.idx + 1 }}</span>
    </div>
    <div class="guests-info-operate">
      <div v-if="!guest.unFilledGuest || guest.isEdit" class="guestInfoEditCon">
        <div class="operate-btn">
          <img class="btn-icon"
               src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon09.png" />
        </div>
        <div class="btn-name">
          {{guest.passengerName}}
        </div>
      </div>
      <div v-else class="guestInfoEditCon">
        <div class="operate-btn">
          <img class="btn-icon"
              src="https://resource.rcclchina.com.cn/RcclHP/BOOKING/icon06.png"/>
        </div>
        <div class="btn-name fc-blue">添加乘客</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuestSelectView",
  props: {
    idx: Number,
    guest: {
      type: Object,
      default() {
        return null;
      }
    },
    contactMode: String,
    sessionToken: String
  },
  methods: {
    selectClick() {
      this.$emit("selectClick", { guest: this.guest, contactMode: this.contactMode, sessionToken: this.sessionToken})
    }
  }
}
</script>

<style lang="less" scoped>
.guests-info-detail {
  border: 1px solid #4a90e2;
  position: relative;
  float: left;
  width: 73px;
  height: 66px;
  margin-left: 8px;
  margin-bottom: 0;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  &:first-child {
    margin-left: 0;
  }
  & .detail-title {
    width: 47px;
    text-align: center;
    color: #808080;
    position: absolute;
    top: -0.4559rem;
    font-size: 12px;
    background-color: #fff;
    left: 50%;
    transform: translateX(-50%);
    & .detail-num {
      color: #4a90e2;
    }
  }
  & .guests-info-operate {
    text-align: center;
    .guestInfoPlusCon {
      line-height: 1;
    }
    .operate-btn {
      width: 39px;
      margin: 16px auto 0;
      &.isEmpty {
        margin-top: 13px;
      }
    }
    & .btn-icon {
      width: 15px;
      height: 15px;
      margin: 0 auto 0;
      &.isEmpty {
        margin-top: 2px;
      }
    }
    & .btn-name {
      font-size: 12px;
      color: #333;
      width: 71px;
      overflow: hidden;
      text-overflow: ellipsis;
      &.fc-blue {
        color: #4A90E2;
      }
    }
  }
}
</style>